import $ from 'jquery';
import 'bootstrap/js/dist/collapse.js';
import 'bootstrap/js/dist/modal.js';
import project from './campaign/Project.mjs';
import './campaign/Tracking.mjs';

export default class Campaign {
  constructor() {
    /*
     * Session management
     */
    project.userSession.init();

    const $teaserFullscreen = $('.ef-teaser-fullscreen');
    if ($teaserFullscreen.length) {
      import(/* webpackChunkName: "TeaserFullscreen" */ './campaign/TeaserFullscreen.mjs');
    }

    /*
     * Price Page
     */
    (async () => {
      const $isPricePage = $('#code-steps');
      if ($isPricePage.length) {
        import(/* webpackChunkName: "PricePage" */ './campaign/PricePage.mjs');
      }
    })();

    /*
     * Game
     */
    (async () => {
      if ($('#game-wrapper').length) {
        import(/* webpackChunkName: "GameFroehlicheProzente" */ './campaign/GameFroehlicheProzente.mjs');
      }
    })();

    /*
     * Barcode
     */
    (async () => {
      const $barcode = $('#js_tx-project-barcode');
      if ($barcode.length) {
        import(/* webpackChunkName: "Barcode" */ './campaign/Barcode.mjs');
      }
    })();

    /*
     * Submit Code Form
     */
    (async () => {
      const $submitCodeForm = $('#code-send-segment-content');
      if ($submitCodeForm.length) {
        import(/* webpackChunkName: "SubmitCodeForm" */ './campaign/SubmitCodeForm.mjs');
      }
    })();

    /*
     * Store list
     */
    (async () => {
      const $storeList = $('#campaign-store-list-holder');
      if ($storeList.length) {
        import(/* webpackChunkName: "StoreList" */ './campaign/StoreList.js');
      }
    })();


    const $formSearch = $('.js_form-store-search');
    if ($formSearch.length) {
      import(/* webpackChunkName: "FormStoreSearch" */ './campaign/FormStoreSearch.mjs').then((values) => {
        const FormStoreSearch = values.default; // Workaround for Webpack version difference

        $formSearch.each((index, form) => {
          new FormStoreSearch(form).init();
        });
      });
    }

    /*
     * Additions
     */
    /* move modal to body */
    $.each($('div.modal'), function(index, modal) {
      if ($(modal).parent().get(0).tagName != 'BODY') {
        $('body').append(modal);
      }
    });
  }
}
